module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Text-height-f46351a10b1c069f5fe3afeae50ad6e7.svg";